import { EventEmitter } from 'expo';
export const LocationEventEmitter = new EventEmitter();

//# sourceMappingURL=LocationEventEmitter.web.js.map
